<div class="checkbox-grid__header">
  <div class="checkbox-grid__header-label">
    <p class="t-data t-bold">{{ gridTitle }}</p>
  </div>
  <div class="checkbox-grid__header-cell-wrapper">
    @for (column of headerCells; track column) {
      <div>
        <checkbox-grid-header-cell
          [column]="column"
          [isBulkSupported]="isBulkSupported"
          (columnUpdated)="onColumnUpdated($event)"
        >
        </checkbox-grid-header-cell>
      </div>
    }
  </div>
</div>
